// Mock API für die Browser-Vorschau
const INIT_DOORS = Array.from({length: 24}, (_, i) => ({
  id: i + 1,
  day: i + 1,
  youtubeUrl: '',
  title: `Türchen ${i + 1}`,
  description: ''
}));

const INIT_SETTINGS = {
  bgImage: 'https://images.unsplash.com/photo-1543258103-a62bdc069871?q=80&w=2574&auto=format&fit=crop',
  simulatedDate: new Date().toISOString(),
  useSimulatedDate: false,
  logoLink: ''
};

const getStorage = (key, fallback) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : fallback;
};

const setStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

if (!localStorage.getItem('advent_doors')) setStorage('advent_doors', INIT_DOORS);
if (!localStorage.getItem('advent_settings')) setStorage('advent_settings', INIT_SETTINGS);

export const api = {
  getDoors: async () => getStorage('advent_doors'),
  updateDoor: async (id, data) => {
    const doors = getStorage('advent_doors');
    const index = doors.findIndex(d => d.id === id);
    if (index !== -1) {
      doors[index] = {...doors[index], ...data};
      setStorage('advent_doors', doors);
    }
    return doors[index];
  },
  getSettings: async () => getStorage('advent_settings'),
  updateSettings: async (data) => {
    const settings = {...getStorage('advent_settings'), ...data};
    setStorage('advent_settings', settings);
    return settings;
  },
  login: async (username, password) => {
    if (username === 'admin') {
      localStorage.setItem('advent_token', 'mock-token');
      return {token: 'mock-token'};
    }
    throw new Error('Ungültige Zugangsdaten');
  },
  changePassword: async (newPassword) => {
    console.log("Mock: Passwort geändert zu", newPassword);
    return { success: true };
  },
  logout: () => localStorage.removeItem('advent_token'),
  isAuthenticated: () => !!localStorage.getItem('advent_token')
};